import * as React from 'react';
import { useIntl, useSelector, statusSuccess } from '@grandvisionhq/state';
import { getPrescription } from '../../../state/configurator/selectors.js';
import { PrescriptionUploadSummary } from './PrescriptionUploadSummary.js';

const PrescriptionUploadSummaryContainer = ({ hideDividers , className , title ='products.glasses.configurator.footer.prescription.title' ,  })=>{
    const { getLabel  } = useIntl();
    const prescription = useSelector(getPrescription);
    if (!statusSuccess(prescription) || !prescription.result.uploadReferences) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PrescriptionUploadSummary, {
        className: className,
        title: getLabel(title),
        uploadReferences: prescription.result.uploadReferences,
        hideDividers: hideDividers
    });
};

export { PrescriptionUploadSummaryContainer };
//# sourceMappingURL=PrescriptionUploadSummaryContainer.js.map
